export default "__VITE_ASSET__c8a80567__"